import { render, staticRenderFns } from "./forumReply.vue?vue&type=template&id=5a79b8ce"
import script from "./forumReply.vue?vue&type=script&lang=js"
export * from "./forumReply.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports